export const BUTTON_FONT_SIZE_DESKTOP = '14px';
export const BUTTON_FONT_SIZE_MOBILE = '11px';
